<template>
    <div>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="邮件主题" prop="subject">
                <el-input v-model="form.subject" style="width: 25%"></el-input>
            </el-form-item>
            <el-form-item label="发送类型" prop="sendType">
                <el-select v-model="form.sendType" placeholder="请选择发送类型" style="width: 25%">
                    <el-option label="模板发送" value="1"></el-option>
                    <el-option label="自定义发送" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-show="form.sendType == 1" label="模板选择" prop="templateId">
                <el-select v-model="form.templateId" placeholder="请选择" style="width: 25%">
                    <el-option
                            v-for="item in templates"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="收件人" prop="recipient">
                <el-input v-model="form.recipient" style="width: 50%" placeholder="多个人用英文 ; 隔开"></el-input>
            </el-form-item>
            <el-form-item v-show="form.sendType == 2" label="发送内容" prop="content">
                <div style="border: 1px solid #ccc; margin-top: 10px">
                    <UEditor ref="ue"></UEditor>
                </div>
            </el-form-item>
            <el-form-item>
                <el-button @click="clearForm">清空</el-button>
                <el-button v-preventReClick type="primary" @click="onSubmit('form')">发送</el-button>
                <el-button v-show="form.sendType == 2" type="info" @click="onPreview()">预览</el-button>
            </el-form-item>
        </el-form>

        <!--预览弹框-->
        <el-dialog
                title="邮件发送预览"
                :visible.sync="dialogVisible"
                width="40%">
            <div style="border: 2px solid;">
                <div style="margin: 10px" v-html="preview"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import UEditor from '@/common/UEditor'

    export default {
        name: "SendEmail",
        components: { UEditor },
        data() {
            return {
                preview: "",
                form: {
                  content: ''
                },
                templates: [],
                rules: {
                    subject: [
                        {required: true, message: '请输入邮件主题', trigger: 'blur'}
                    ],
                    sendType: [
                        {required: true, message: '请选择发送类型', trigger: 'blur'}
                    ],
                    recipient: [
                        {required: true, message: '请至少输入一个邮件地址', trigger: 'blur'}
                    ]
                },
                dialogVisible: false,
            }
        },
        created() {
            this.templateList()
        },
        methods: {
            clearForm() {
                this.form = {}
                this.$refs.ue.contents = ''
            },
            templateList() {
                this.$axios.get('/uxm/email-template/list', {}).then(res => {
                    this.templates = res.data.data
                })
            },
            onPreview() {
                this.dialogVisible = true
                this.preview = this.$refs.ue.contents
            },
            onSubmit(form) {
                if (this.form.sendType == 1) {
                    if (null == this.form.templateId) {
                        this.$message.error('模板不能为空，请选择模板！');
                        return false;
                    }
                } else {
                    if (this.$refs.ue.contents == '' || this.$refs.ue.contents == null) {
                        this.$message.error('发送内容不能为空，请输入发送内容！');
                        return false;
                    }
                    this.form.content = this.$refs.ue.contents
                }
                this.$refs[form].validate((valid) => {
                    if (valid) {
                        this.$axios.post('/uxm/email-send/send', this.form)
                            .then(res => {
                                this.$message({
                                    showClose: true,
                                    message: '恭喜你，操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.clearForm()
                                    }
                                });
                            })
                    } else {
                        return false;
                    }
                });
            },
        }
    }
</script>

<style scoped>
</style>
